import {
	Component,
	Input
} from '@angular/core';

import { VideogularComponent } from './videogular/Videogular.Component';
import { IAudioTrack } from './IAudioTrack';
import { PLAYER_USER_PREFERENCE_KEY } from 'vbrick-player-src/shared/userPreference/PlayerUserPreferenceHandler';
import { PlayerUserPreferencesService } from 'vbrick-player-src/shared/userPreference/PlayerUserPreference.Service';

import styles from './VbSubtitleMenuButton.module.less';

@Component({
	selector: 'vb-audio-menu',
	template: `
		<ul *ngIf="audioTracks?.length" role="menu" [ngClass]="styles.leftSubMenu"
			class="playerSettingsSubmenu">
			<li role="none" [ngClass]="styles.subMenuHeading">{{ translations.audio }}</li>
			<li
				*ngFor="let audioTrack of audioTracks"
				role="none">
				<button type="button"
role="menuitem"
					class="btn-link dropdown-item"
					(click)="onTrackChange(audioTrack);"
					[ngClass]="(vgApi.activeAudioTrack$ | async)?.id === audioTrack.id ? selectedCssClass : ''">
					{{ audioTrack.displayLabel }}
					<span *ngIf="audioTrack.default"> ({{ translations.original }}) </span>
				</button>
			</li>
		</ul>
	`,
    standalone: false
})
export class VbAudioMenuComponent {
	@Input() public selectedCssClass: string;
	@Input() public translations: any;
	@Input() public audioTracks: IAudioTrack[];

	public readonly styles = styles;

	constructor(
		public vgApi: VideogularComponent,
		private readonly PlayerUserPreferencesService: PlayerUserPreferencesService,
	) {}


	public onTrackChange(track: IAudioTrack): void {
		this.vgApi.setActiveAudioTrack(track);
		this.PlayerUserPreferencesService.setPreference<IAudioTrack>(PLAYER_USER_PREFERENCE_KEY.AUDIO_TRACK, track);
	}

}
